export const SOCKET_EVENTS = {
  CONNECTION: "connection",
  DISCONNECT: "disconnect",
  ERROR: "error_message", 
  
  JOIN_CONVERSATION: "joinConversation",
  SEND_MESSAGE: "sendMessage",
  NEW_MESSAGE: "newMessage",
  
  MESSAGE_EDIT: "editMessage",
  MESSAGE_EDITED: "messageEdited",
  MESSAGE_DELETE: "deleteMessage",
  MESSAGE_DELETED: "messageDeleted",
  MESSAGE_SEEN: "messageSeen",
  
  TYPING: "typing",
  STOP_TYPING: "stopTyping",
  
  USER_ONLINE: "userOnline",
  USER_OFFLINE: "userOffline",
  
  GROUP_CREATE: "groupCreate",
  GROUP_ADD_MEMBERS: "groupAddMembers",
  GROUP_REMOVE_MEMBER: "groupRemoveMember",
  GROUP_MEMBER_REMOVED: "groupMemberRemoved", 
  GROUP_LEAVE: "groupLeave",
  GROUP_LEFT: "groupLeft", 
  GROUP_RENAME: "groupRename",
  GROUP_UPDATED: "groupUpdated",
  GROUP_TRANSFER_OWNERSHIP: "groupTransferOwnership", 
  
  MESSAGE_REACTION: "messageReaction", 
};

export const MESSAGE_TYPES = {
  TEXT: "text",
  IMAGE: "image",
  AUDIO: "audio",
  VIDEO: "video",
  FILE: "file",
  SYSTEM: "system", 
};

export const CONVERSATION_TYPES = {
  PRIVATE: "private",
  GROUP: "group",
};